
const digest = '37194532613d8cdc1e36b50bc37adcd6c9fae049727265f23a3266be24d2f073';
const classes = {"errorMessage":"_errorMessage_zol7n_1"};
const css = `._errorMessage_zol7n_1 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: red;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  